import userflow from "userflow.js";

import { getUserflowToken, isUserflowActive } from "./config";

/**
 * Element inference attributes Userflow uses to target DOM elements for flows/tooltips.
 * We include data-tour so flows can target elements marked with data-tour="…" in the app.
 * Must be set before userflow.init(). See: https://docs.userflow.com/docs/dev/element-inference
 */
const INFERENCE_ATTRIBUTE_NAMES = [
  "data-for",
  "data-id",
  "data-testid",
  "data-test-id",
  "data-tour",
  "for",
  "id",
  "name",
  "placeholder",
  "role",
];

if (isUserflowActive) {
  userflow.setInferenceAttributeNames(INFERENCE_ATTRIBUTE_NAMES);
  const token = getUserflowToken();
  if (token) {
    userflow.init(token);
  }
}
